module.exports = __webpack_public_path__ + "45afd851c1a10c1d1cfbbcfa6c82cc65.svg";